/**
 * Constants and configurations for Digitane AI
 */

/**
 * 年齢グループ
 * バックエンドのAgeGroupと同じ値を使用
 */
export enum AgeGroup {
  PRESCHOOL = 'preschool', // 就学前 (0-5歳)
  ELEMENTARY = 'elementary', // 小学生 (6-12歳)
  JUNIOR_HIGH = 'junior_high', // 中学生 (13-15歳)
  HIGH_SCHOOL = 'high_school', // 高校生 (16-18歳)
}

export enum FilterResult {
  PASS = 'pass', // 通過
  WARN = 'warn', // 警告（通過するが記録）
  BLOCK = 'block', // ブロック
}

export enum BlockCategory {
  FORBIDDEN_WORD = 'forbidden_word', // 禁止ワード
  SEXUAL = 'sexual', // 性的コンテンツ
  VIOLENCE = 'violence', // 暴力的コンテンツ
  HATE = 'hate', // ヘイトスピーチ
  HARMFUL = 'harmful', // 有害コンテンツ
  RATE_LIMIT = 'rate_limit', // レート制限
  OTHER = 'other', // その他
}

// Feature flags
export const ENABLE_CHAT_FILE_ATTACHMENT = true;

// セッションタイムアウト（秒単位）
export const SESSION_TIMEOUT = 24 * 60 * 60; // 24時間

// Cookie設定
export const COOKIE_CONFIG = {
  SESSION_COOKIE_NAME: 'digitane_token',
  COOKIE_MAX_AGE: 7 * 24 * 60 * 60, // 7日間（秒単位）
};
